import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import JobsTable from './jobs-table.jsx';


if (document.getElementById('react-component-g4-logistics-portal-cancelled-jobs')) {
  ReactDOM.render(<JobsTable
    url= "/api/v1/portal/jobs/cancelled"
    infiniteScroll={true}
    message_if_none = 'No jobs cancelled yet.'
  />,
document.getElementById('react-component-g4-logistics-portal-cancelled-jobs'));
}
